// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2U_0j","sendOtp":"AuthorizeToLogin_sendOtp__3vmz0"};